import { render } from "./bottom_bar.vue?vue&type=template&id=314bd767"
import script from "./bottom_bar.vue?vue&type=script&lang=js"
export * from "./bottom_bar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__